module.exports = __webpack_public_path__ + "static/media/banner-375.3b7cdb55.jpg";